exports = module.exports = require("./../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#outdated{position:absolute;background-color:#f25648;color:#fff;display:none;overflow:hidden;left:0;position:fixed;text-align:center;text-transform:uppercase;top:0;width:100%;z-index:1500;padding:24px}#outdated h6{font-size:25px;line-height:25px;margin:12px 0}#outdated p{font-size:12px;line-height:12px;margin:0}#outdated #buttonUpdateBrowser{border:2px solid #fff;color:#fff;cursor:pointer;display:block;margin:30px auto 0;padding:10px 20px;position:relative;text-decoration:none;width:230px}#outdated #buttonUpdateBrowser:hover{background-color:#fff;color:#f25648}#outdated .last{height:20px;position:absolute;right:25px;top:10px;width:0}#outdated .last[dir=rtl]{left:25px!important;right:auto!important}#outdated #buttonCloseUpdateBrowser{color:#fff;display:block;font-size:36px;height:100%;line-height:36px;position:relative;text-decoration:none;width:100%}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./~/outdated-browser-rework/outdated-browser-rework.scss
 ** module id = 886
 ** module chunks = 0
 **/